document.getElementById("birthday").addEventListener("change", function(event) {
  const birthday = document.getElementById("birthday").value
  
  const date = new Date(birthday)
  const day = ("0"+date.getDate()).slice(-2)
  const month = ("0" + (date.getMonth()+1)).slice(-2)
  console.log('day', day)
  console.log('month', month)

  document.getElementById("hiddenBirthday").value = day + "/" + month
});

if(document.getElementById("birthdayForm")){
    document.getElementById("birthdayForm").addEventListener("change", function(event) {
    const birthday = document.getElementById("birthdayForm").value
    
    const date = new Date(birthday)
    const day = ("0"+date.getDate()).slice(-2)
    const month = ("0" + (date.getMonth()+1)).slice(-2)
    console.log('day', day)
    console.log('month', month)
  
    document.getElementById("hiddenBirthdayForm").value = day + "/" + month
  });
}

